import { snakeCase } from 'lodash';
import { Dispatch, SetStateAction } from 'react';
import { useLocalStorage } from './use-local-storage';

export enum AccountFeature {
  Timesheets = 'timesheets',
  Financials = 'financials',
}

export const useAccountFeature = (
  feature: AccountFeature,
): [boolean, Dispatch<SetStateAction<boolean>>] => {
  return useLocalStorage<boolean>(
    `__account_features.${snakeCase(feature)}`,
    false,
  );
};
